<div class="card h-100" (click)="clickedCard()">
	<h3>{{ contentTool.title }}</h3>
	<p>{{ contentTool.excerpt }}</p>
</div>